import { isAxiosError } from 'axios'

type UseGetErrorMessage = (error: unknown) => string | undefined

export const useGetErrorMessage: UseGetErrorMessage = (error) => {
  if (!error) {
    return undefined
  }

  const defaultErrorMessage =
    'We encountered an unexpected error when crunching this file. Please try again.'

  if (!isAxiosError(error)) {
    return defaultErrorMessage
  }

  const errorMessage = error.response?.data?.message

  if (
    typeof errorMessage === 'string' &&
    errorMessage ===
      'The file size exceeds the upload limits of 3000 pages or 500MB.'
  ) {
    return errorMessage
  }

  if (Array.isArray(errorMessage)) {
    return errorMessage.join(', ')
  }

  if (typeof errorMessage === 'string') {
    return errorMessage
  }

  return defaultErrorMessage
}
